import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import {
  DefinitionDataSourceType,
  IRequirementDefinitionResponse,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { useConfirmCreateRequirementModal } from "../../../components/CreateRequirementDefinitionForm/useConfirmCreateRequirementModal";
import { CreateRequirementDefinitionFormValues } from "../../../../Requirements/types";
import { convertFormApprovalDataToReviewStrategy } from "../../../components/CreateRequirementDefinitionForm/utils";
import { CreateRequirementDefinitionInsuranceCoveragePartialForm } from "./types";
import { createMonitorSettings } from "../../../../../services/api/insurance/monitorSettings/createMonitorSettings";

type Params = {
  engagementId?: string;
  onSuccess: (requirement: IRequirementDefinitionResponse) => void;
};

export const useCreateInsuranceCoverageRequirementDefinition = ({
  engagementId,
  onSuccess
}: Params) => {
  const { openSnackbar } = useWSSnackbar();
  const confirmCreateRequirementModal = useConfirmCreateRequirementModal();

  const onSubmit = async (
    formValues: CreateRequirementDefinitionFormValues &
      CreateRequirementDefinitionInsuranceCoveragePartialForm
  ) => {
    const monitorSettings = await createMonitorSettings({
      ...formValues
    });
    // For Insurance Coverage, we'll create the requirement directly without a separate settings API
    // The dataSourceId can be generated or handled by the backend
    const dataSourceId = monitorSettings.insuranceCoverageMonitorSettingsId; // Temporary ID generation

    await confirmCreateRequirementModal.open({
      engagementId,
      dataSourceType: DefinitionDataSourceType.InsuranceCoverageMonitorSettings,
      dataSourceId,
      name: formValues.name,
      description: formValues.description,
      requirementType: RequirementType.InsuranceCoverage,
      reviewStrategy: convertFormApprovalDataToReviewStrategy(formValues),
      onSuccess(requirement) {
        openSnackbar({
          theme: "dark",
          type: "success",
          message: "Insurance coverage requirement created successfully"
        });
        onSuccess?.(requirement);
      }
    });
  };

  return {
    onSubmit,
    errors: null,
    isLoading: false,
    isEnabled: true
  };
};
